import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Inquiries() {
  const [data, setData] = useState({ video: [], distribution: [] });
  useEffect(() => { api.get("/admin/inquiries").then((r) => setData(r.data)); }, []);

  return (
    <div data-testid="admin-inquiries">
      <div className="label-mono mb-2">/ Submissions</div>
      <h1 className="font-display text-4xl font-bold tracking-tighter mb-8">Inquiries</h1>

      <div className="mb-12">
        <div className="label-mono mb-3 text-cyan-400">/ Video Production ({data.video.length})</div>
        <div className="space-y-3">
          {data.video.map((v) => (
            <div key={v.id} className="p-5 rounded-xl border border-white/5 bg-[#121215]" data-testid={`vinq-${v.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="font-display font-semibold">{v.artist_name}</div>
                  <div className="text-zinc-500 text-xs font-mono mt-1">{new Date(v.created_at).toLocaleString()}</div>
                </div>
                <span className="badge muted">{v.budget || "no budget"}</span>
              </div>
              <div className="grid sm:grid-cols-2 gap-3 mt-3 text-xs text-zinc-400">
                <div>📍 {v.location || "—"}</div>
                <div>📷 {v.instagram || "—"}</div>
                <div>▶️ {v.youtube || "—"}</div>
              </div>
              {v.notes && <p className="text-sm mt-3 text-zinc-300 whitespace-pre-wrap">{v.notes}</p>}
            </div>
          ))}
          {data.video.length === 0 && <div className="text-zinc-500 text-sm">No video inquiries yet.</div>}
        </div>
      </div>

      <div>
        <div className="label-mono mb-3 text-cyan-400">/ Distribution ({data.distribution.length})</div>
        <div className="space-y-3">
          {data.distribution.map((d) => (
            <div key={d.id} className="p-5 rounded-xl border border-white/5 bg-[#121215]" data-testid={`dinq-${d.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="font-display font-semibold">{d.stage_name || d.company_name}</div>
                  <div className="text-zinc-500 text-xs font-mono mt-1">{d.email} · {new Date(d.created_at).toLocaleString()}</div>
                </div>
                <span className={`badge ${d.type === "music" ? "" : "muted"}`}>{d.type}</span>
              </div>
              <div className="grid sm:grid-cols-3 gap-2 mt-3 text-xs text-zinc-400">
                {Object.entries(d).filter(([k]) => !["_id","id","email","stage_name","company_name","type","created_at","status"].includes(k)).map(([k, val]) => val ? <div key={k}><span className="text-zinc-600">{k}:</span> {String(val).slice(0, 60)}</div> : null)}
              </div>
            </div>
          ))}
          {data.distribution.length === 0 && <div className="text-zinc-500 text-sm">No distribution inquiries yet.</div>}
        </div>
      </div>
    </div>
  );
}
